import { render } from "./ChildOtherRecordList.vue?vue&type=template&id=0443d6a4&scoped=true&ts=true"
import script from "./ChildOtherRecordList.vue?vue&type=script&lang=ts"
export * from "./ChildOtherRecordList.vue?vue&type=script&lang=ts"

import "./ChildOtherRecordList.vue?vue&type=style&index=0&id=0443d6a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0443d6a4"]])

export default __exports__